import { render, staticRenderFns } from "./AddProductsStep.vue?vue&type=template&id=b207d330&scoped=true&"
import script from "./AddProductsStep.vue?vue&type=script&lang=js&"
export * from "./AddProductsStep.vue?vue&type=script&lang=js&"
import style0 from "./AddProductsStep.vue?vue&type=style&index=0&id=b207d330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b207d330",
  null
  
)

export default component.exports